module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "sidebar__wrap sidebar__wrap--teacher"
  }, [_c('sidebar', {
    staticClass: "sidebar--teacher",
    class: _vm.mini ? 'sidebar--mini' : 'sidebar--expanded',
    attrs: {
      "user": _vm.user,
      "collectionPrefix": "klas",
      "collectionName": this.group.name,
      "collectionLink": {
        name: 'students.overview'
      },
      "backLink": {
        name: 'groups'
      },
      "backLinkTitle": "Klassen",
      "isCollectionActive": _vm.$route.name === 'students.overview'
    },
    on: {
      "viewCollectionInfo": _vm.openSettings
    }
  }, [(_vm.mini) ? _c('div', {
    staticClass: "sidebar__touch-block",
    on: {
      "!touchstart": function($event) {
        _vm.prevent($event)
      }
    }
  }) : _vm._e(), _c(_vm.contentComponent, {
    tag: "component",
    attrs: {
      "group": _vm.group,
      "groupTerm": _vm.groupTerm,
      "isDemo": _vm.isDemo
    }
  })], 1), (_vm.student != null) ? _c('sidebar-workspace', {
    attrs: {
      "user": _vm.student,
      "group": _vm.group,
      "loading": _vm.loadingUserProgress,
      "hideUnfinished": true,
      "isInspecting": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9699352c","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/sidebar/SidebarTeacher.vue
// module id = hB1x
// module chunks = 1